import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkip = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.5 3.41934V14.5807C1.5 14.6718 1.52489 14.7612 1.57199 14.8392C1.61909 14.9172 1.68661 14.9808 1.76725 15.0232C1.84789 15.0656 1.93859 15.0852 2.02955 15.0798C2.1205 15.0744 2.20826 15.0443 2.28333 14.9927L10.4 9.41201C10.467 9.36615 10.5217 9.30467 10.5596 9.23288C10.5974 9.16109 10.6172 9.08116 10.6172 9.00001C10.6172 8.91885 10.5974 8.83892 10.5596 8.76713C10.5217 8.69534 10.467 8.63386 10.4 8.58801L2.28333 3.00734C2.20826 2.95571 2.1205 2.92557 2.02955 2.92019C1.93859 2.9148 1.84789 2.93437 1.76725 2.97679C1.68661 3.0192 1.61909 3.08284 1.57199 3.16084C1.52489 3.23884 1.5 3.32822 1.5 3.41934V3.41934Z",
		stroke: "#ADB3C4",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 13.9,
		y1: 3.9,
		x2: 13.9,
		y2: 14.1,
		stroke: "#8C94AA",
		strokeWidth: 1.8,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgSkip);
export default ForwardRef;
